// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"340":"abc27c44","347":"9a3e1bc8","551":"84341b40","917":"b1b60a2b"}[chunkId] + ".chunk.css";
};